import { auth } from '@monorepo/utils/firebase'

export const deleteAccount = async () => {
  if (auth().currentUser) await auth().currentUser?.delete()
}
